import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#3D2817] text-white">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12">
          <div className="flex items-center gap-3 mb-4 md:mb-0">
            <img 
              src="https://public.readdy.ai/ai/img_res/007688b8-3d79-4152-adb5-396ec7a60c17.png" 
              alt="The Bridge Street Café" 
              className="h-10 w-auto"
            />
            <span className="font-serif text-2xl text-[#FAF7F2]">The Bridge Street Café</span>
          </div>
          <p className="text-[#FAF7F2] font-light">Serving Otley since 2018</p>
        </div>

        {/* Navigation Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h3 className="text-[#FAF7F2] font-bold text-lg mb-4">Menu</h3>
            <ul className="space-y-2">
              <li><Link to="/menu" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Breakfast</Link></li>
              <li><Link to="/menu" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Lunch</Link></li>
              <li><Link to="/menu" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Coffee</Link></li>
              <li><Link to="/menu" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Cakes</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[#FAF7F2] font-bold text-lg mb-4">About</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Our Story</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Local Suppliers</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Community</Link></li>
              <li><a href="mailto:jobs@bridgestreetcafe.co.uk" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Jobs</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[#FAF7F2] font-bold text-lg mb-4">Visit</h3>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Location</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Opening Hours</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contact</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Parking Info</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[#FAF7F2] font-bold text-lg mb-4">Connect</h3>
            <ul className="space-y-2">
              <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Facebook</a></li>
              <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Instagram</a></li>
              <li><a href="https://tripadvisor.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors cursor-pointer">TripAdvisor</a></li>
              <li><a href="mailto:hello@bridgestreetcafe.co.uk" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Email</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-[#2D1F12] py-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            {/* Left Image */}
            <div className="rounded-2xl overflow-hidden" style={{ height: '150px' }}>
              <img 
                src="https://public.readdy.ai/ai/img_res/d5a496f7ed464e3c7b78c93d490901c2.jpg" 
                alt="Coffee at The Bridge Street Café" 
                className="w-full h-full object-cover"
              />
            </div>

            {/* Middle Tagline */}
            <div className="text-center">
              <p className="font-serif text-2xl text-[#FAF7F2] leading-relaxed">
                Great Coffee.<br />
                Good Food.<br />
                Better Company.
              </p>
            </div>

            {/* Right Subscribe */}
            <div>
              <p className="text-gray-300 text-sm mb-4">
                Join our mailing list for weekly specials and community news
              </p>
              <div className="flex gap-2">
                <input 
                  type="email" 
                  placeholder="Your email address" 
                  className="flex-1 px-4 py-3 bg-transparent border-2 border-gray-500 rounded-full text-[#FAF7F2] placeholder-gray-400 focus:outline-none focus:border-[#C17855] text-sm"
                />
                <button className="px-6 py-3 bg-[#C17855] text-white rounded-full font-medium hover:bg-[#A66545] transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2">
                  <span className="hidden sm:inline">Subscribe</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-8 border-t border-gray-600 text-center">
            <p className="text-gray-400 text-sm mb-2">
              © 2025 The Bridge Street Café. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-500 hover:text-gray-300 text-xs transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}